<div class="hp-promo-sliders-wrapper">
  <app-promo-banner></app-promo-banner>
  <app-loan-slider></app-loan-slider>
</div>
<app-loan-application-steps></app-loan-application-steps>

<div class="layout-fluid-constrained layout-align-center">
  <section>
    <div class="section-head">
      <span class="eyebrow">Видове кредити</span>
      <h2>Изберете подходящ кредит според нуждите си</h2>
      <p>MiniZaem.bg предлага два основни типа онлайн кредитиране - безлихвен кредит и кредит на вноски. Чрез калкулатора можете да изберете вида на кредита, желаната сума и срока за връщане, преди да подадете заявка.</p>
    </div>
    <div class="credit-cards">
      <article class="credit-card">
        <span class="tag">Краткосрочно решение</span>
        <h3>Безлихвен кредит</h3>
        <p>Подходящ за краткосрочна нужда от средства, когато искате да върнете заетата сума в предварително избрания срок. При посочените условия на сайта примерният безлихвен кредит е с 0% ГПР за конкретния промоционален период.</p>
      </article>
      <article class="credit-card green">
        <span class="tag">Разсрочено изплащане</span>
        <h3>Кредит на вноски</h3>
        <p>Подходящ при нужда от по-голяма сума и разсрочено изплащане. Кредитът на вноски позволява по-дълъг срок и по-ниска месечна вноска според избраните параметри.</p>
      </article>
    </div>
  </section>
</div>

<section class="section alt">
  <div class="layout-fluid-constrained layout-align-center">

    <div class="section-head">
      <span class="eyebrow">Прозрачност</span>
      <h2>Ясни условия преди кандидатстване</h2>
      <p>Преди да кандидатствате, можете да видите избраната сума, периода на ползване, броя вноски, сумата за връщане и ГПР директно в калкулатора. Така получавате предварителна яснота за основните параметри на кредита.</p>
    </div>
    <div class="examples">
      <article class="example">
        <h3>Типичен пример за “безлихвен до 350 €”</h3>
        <p>За кредит на стойност 200 € ползван за 5 дни. Лихвата за посочения период е в размер на 0 евро. Общата сума за връщане е 200 евро, а годишният процент на разходите (ГПР) – 0%. При изплащане в интервала от 61 до 360 дни ГПР варира от 49.90% до максимален 50.69%.</p>
      </article>
      <article class="example">
        <h3>Типичен пример за “кредит на вноски”</h3>
        <p>За кредит на стойност 1000 € със срок на връщане 12 месеца. Лихвата е в размер на 68.46 евро, а годишният процент на разходите за настоящия финансов пример е 51.34%. Общата сума за връщане за целия период на кредита е 1238.46 €.</p>
      </article>
    </div>
    <p class="important"><strong>Важно:</strong> Финалните условия се определят след разглеждане на заявката и подписване на договора.</p>
  </div>
</section>
<div class="layout-fluid-constrained layout-align-center">
  <section class="section">
    <div class="section-head">
      <span class="eyebrow">Само 4 стъпки</span>
      <h2>Как се кандидатства за бърз кредит онлайн</h2>
    </div>
    <div class="steps">
      <div class="step">
        <div class="step-num" aria-hidden="true">1</div>
        <h3>Избор на кредит</h3>
        <p>Изберете типа кредит, сумата и срока чрез онлайн калкулатора.</p>
      </div>
      <div class="step">
        <div class="step-num" aria-hidden="true">2</div>
        <h3>Онлайн кандидатстване</h3>
        <p>Попълнете въпросника за кандидатстване. Попълването отнема около 10 минути.</p>
      </div>
      <div class="step">
        <div class="step-num" aria-hidden="true">3</div>
        <h3>Разглеждане на заявката</h3>
        <p>След подаване на заявката ще получите отговор след разглеждане на кандидатурата. Отговорът може да бъде изпратен чрез SMS, имейл или телефонно обаждане.</p>
      </div>
      <div class="step">
        <div class="step-num" aria-hidden="true">4</div>
        <h3>Получаване на средствата</h3>
        <p>След потвърждение и подписване на договора средствата могат да бъдат получени по банков път или на каса на EasyPay.</p>
      </div>
    </div>
  </section>
</div>
<section class="section alt">
  <div class="layout-fluid-constrained layout-align-center">
    <div class="section-head">
      <span class="eyebrow">Кой може да кандидатства</span>
      <h2>Изисквания за кандидатстване</h2>
    </div>
    <div class="req-grid">
      <div class="req-card">
        <h3>За да кандидатствате, трябва да имате:</h3>
        <ul class="req-list">
          <li><span class="check" aria-hidden="true">✔</span> Навършени 18 години</li>
          <li><span class="check" aria-hidden="true">✔</span> Постоянно живеене в България</li>
          <li><span class="check" aria-hidden="true">✔</span> Постоянни доходи</li>
          <li><span class="check" aria-hidden="true">✔</span> Мобилен телефон и имейл адрес</li>
        </ul>
        <p style="margin-top:14px;font-size:15px">Важно е да кандидатствате само за сума, която можете да върнете в срок.</p>
      </div>
      <div class="req-card blue">
        <h3>Отговорна оценка на всяка заявка</h3>
        <p>MiniZaem.bg прилага принципи на отговорно кредитиране. Заявките се разглеждат на база вътрешна оценка, справки в Централния кредитен регистър на БНБ и проверка на официални доходи.</p>
      </div>
    </div>
  </div>
</section>
<section class="section">
  <div class="layout-fluid-constrained layout-align-center">
    <div class="section-head">
      <span class="eyebrow">Предимства</span>
      <h2>Защо да изберете MiniZaem.bg</h2>
      <p>MiniZaem.bg е услуга за онлайн кредитиране с фокус върху прозрачни условия, удобен процес и коректно отношение към клиентите. Компанията има над 15 години история и е финансова институция с удостоверение № BGR000211, издадено от БНБ на 19.10.2010 г.</p>
    </div>
    <div class="perks">
      <div class="perk">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1e95d4" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="3" y="4" width="18" height="14" rx="2"></rect>
          <line x1="3" y1="20" x2="21" y2="20"></line>
        </svg>
        <p>Онлайн кандидатстване без посещение на офис</p>
      </div>
      <div class="perk">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8fc043" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9"></circle>
          <polyline points="8 12.5 11 15.5 16 9.5"></polyline>
        </svg>
        <p>Ясни условия и всички разходи, включени в ГПР</p>
      </div>
      <div class="perk">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1e95d4" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9"></circle>
          <polyline points="12 7 12 12 15.5 14"></polyline>
        </svg>
        <p>Възможност за предсрочно погасяване без такси и неустойки</p>
      </div>
      <div class="perk">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8fc043" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z"></path>
        </svg>
        <p>Кредити без поръчители и гаранции</p>
      </div>
      <div class="perk">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f7941e" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M20.8 9.2L12 3 3.2 9.2 12 15.4z"></path>
          <path d="M6 12v6c3 2.5 9 2.5 12 0v-6"></path>
        </svg>
        <p>Възможност за отстъпки за лоялни клиенти</p>
      </div>
      <div class="perk">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1e95d4" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="2" y="6" width="20" height="12" rx="2"></rect>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
        <p>Получаване на средствата по банков път или чрез EasyPay</p>
      </div>
    </div>
  </div>
</section>

<section class="section alt">
  <div class="layout-fluid-constrained layout-align-center">
    <div class="duo">
      <div class="panel">
        <h2>Отговорно кредитиране и важна информация</h2>
        <p>Кредитът е финансов ангажимент и трябва да бъде избран внимателно. MiniZaem.bg не насърчава кандидатстване за суми, които не можете да върнете в срок.</p>
        <p>Информация за отпуснатите кредити се подава към Централния кредитен регистър на БНБ. Просрочените задължения могат да влошат кредитната история и да ограничат възможностите за бъдещо кредитиране от други финансови институции.</p>
        <p>При затруднения с плащането е препоръчително да се свържете с MiniZaem.bg навреме, за да бъдат обсъдени възможните варианти според условията на договора.</p>
      </div>
      <div class="panel soft">
        <h2>Сигурност при онлайн кандидатстване</h2>
        <p>Платформата на MiniZaem.bg използва защитена връзка, а личните данни се обработват съгласно приложимите правила за защита на личната информация. При кандидатстване се изискват данни, необходими за идентификация, контакт и оценка на кредитоспособността.</p>
      </div>
    </div>
  </div>
</section>
<section class="section">
  <div class="layout-fluid-constrained layout-align-center">
    <div class="section-head">
      <span class="eyebrow">Полезна информация</span>
      <h2>Често задавани въпроси</h2>
    </div>
    <div class="faq">
      <details open="">
        <summary>Как мога да кандидатствам за бърз кредит онлайн?</summary>
        <p>Изберете тип кредит, сума и срок чрез калкулатора, след което попълнете онлайн въпросника. След разглеждане на заявката ще получите отговор чрез SMS, имейл или телефонно обаждане.</p>
      </details>
      <details>
        <summary>Какви са основните изисквания за кандидатстване?</summary>
        <p>Трябва да имате навършени 18 години, да живеете в България, да имате постоянни доходи, мобилен телефон и имейл адрес. Важно е да кандидатствате само ако можете да върнете избраната сума в срок.</p>
      </details>
      <details>
        <summary>Колко време отнема кандидатстването?</summary>
        <p>Попълването на въпросника отнема около 10 минути. След подаване на заявката тя се разглежда и получавате отговор по посочения от вас канал за контакт.</p>
      </details>
      <details>
        <summary>Как мога да получа парите?</summary>
        <p>След одобрение, потвърждение и подписване на договора средствата могат да бъдат получени по банков път или на каса на EasyPay.</p>
      </details>
      <details>
        <summary>Мога ли да погася кредита предсрочно?</summary>
        <p>Да. При предсрочно погасяване сумата за връщане се преизчислява според периода на реално ползване. Няма такси за предсрочно погасяване.</p>
      </details>
      <details>
        <summary>Има ли скрити такси?</summary>
        <p>Условията на сайта посочват, че всички разходи са включени в ГПР. Преди кандидатстване можете да видите основните параметри в калкулатора.</p>
      </details>
      <details>
        <summary>Какво се случва при просрочие?</summary>
        <p>Просрочието може да доведе до допълнителни разходи по събиране, начисляване на законова лихва и отразяване в Централния кредитен регистър. Това може да повлияе негативно на бъдещи възможности за кредитиране.</p>
      </details>
    </div>
  </div>
</section>
<section class="final-cta">
  <svg class="skyline" viewBox="0 0 1440 340" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <path fill="currentColor" d="M0 340V220h40v-60h30v60h50V120h20V80h15v40h20v100h60V190h50v150h40V160h35v-40h20v40h35v180h70V200h55v-70h25v70h50v140h60V150h45v190h50V230h60v-40h25v40h55v110h70V180h40v-60h20v60h45v160h60V210h50v130h55V170h30v-30h18v30h32v200z"></path>
  </svg>
  <div class="layout-fluid-constrained layout-align-center wrap">
    <h2>Изберете сума и кандидатствайте онлайн</h2>
    <p>Използвайте калкулатора, за да изберете подходяща сума и срок. Прегледайте условията, попълнете онлайн заявката и изчакайте отговор след разглеждане на кандидатурата.</p>
    <a href="#calculator">Вземи сега</a>
  </div>
</section>
<app-contact-section></app-contact-section>
